export const plum = {
  1: { value: { base: '{colors.plum.light.1}', _dark: '{colors.plum.dark.1}' } },
  2: { value: { base: '{colors.plum.light.2}', _dark: '{colors.plum.dark.2}' } },
  3: { value: { base: '{colors.plum.light.3}', _dark: '{colors.plum.dark.3}' } },
  4: { value: { base: '{colors.plum.light.4}', _dark: '{colors.plum.dark.4}' } },
  5: { value: { base: '{colors.plum.light.5}', _dark: '{colors.plum.dark.5}' } },
  6: { value: { base: '{colors.plum.light.6}', _dark: '{colors.plum.dark.6}' } },
  7: { value: { base: '{colors.plum.light.7}', _dark: '{colors.plum.dark.7}' } },
  8: { value: { base: '{colors.plum.light.8}', _dark: '{colors.plum.dark.8}' } },
  9: { value: { base: '{colors.plum.light.9}', _dark: '{colors.plum.dark.9}' } },
  10: { value: { base: '{colors.plum.light.10}', _dark: '{colors.plum.dark.10}' } },
  11: { value: { base: '{colors.plum.light.11}', _dark: '{colors.plum.dark.11}' } },
  12: { value: { base: '{colors.plum.light.12}', _dark: '{colors.plum.dark.12}' } },
  a1: { value: { base: '{colors.plum.light.a1}', _dark: '{colors.plum.dark.a1}' } },
  a2: { value: { base: '{colors.plum.light.a2}', _dark: '{colors.plum.dark.a2}' } },
  a3: { value: { base: '{colors.plum.light.a3}', _dark: '{colors.plum.dark.a3}' } },
  a4: { value: { base: '{colors.plum.light.a4}', _dark: '{colors.plum.dark.a4}' } },
  a5: { value: { base: '{colors.plum.light.a5}', _dark: '{colors.plum.dark.a5}' } },
  a6: { value: { base: '{colors.plum.light.a6}', _dark: '{colors.plum.dark.a6}' } },
  a7: { value: { base: '{colors.plum.light.a7}', _dark: '{colors.plum.dark.a7}' } },
  a8: { value: { base: '{colors.plum.light.a8}', _dark: '{colors.plum.dark.a8}' } },
  a9: { value: { base: '{colors.plum.light.a9}', _dark: '{colors.plum.dark.a9}' } },
  a10: { value: { base: '{colors.plum.light.a10}', _dark: '{colors.plum.dark.a10}' } },
  a11: { value: { base: '{colors.plum.light.a11}', _dark: '{colors.plum.dark.a11}' } },
  a12: { value: { base: '{colors.plum.light.a12}', _dark: '{colors.plum.dark.a12}' } },
}
